
export function formatTimeShort(d: Date) {

  let hr = d.getHours();
  const minutes = d.getMinutes();
  let min = '';
  if (minutes < 10) {
    min = `0${min}`;
  } else {
    min = minutes.toString();
  }

  let ampm = 'am';
  if (hr > 12) {
    hr -= 12;
    ampm = 'pm';
  }

  return `${hr}:${min} ${ampm}`;
}

export function formatDateShort(date: Date) {
  return new Intl.DateTimeFormat('en-US').format(date);
}
